import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category', label: '版块分类' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-compass-3-line text-2xl text-primary-500"></i>
            </div>
            <span className="font-heading text-xl font-semibold text-foreground-950">
              海角论坛
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              登录
            </button>
            <button className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
              注册
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium py-2 transition-colors duration-200 ${
                  location.pathname === link.to ? 'text-primary-500' : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 pt-3 border-t border-background-200">
              <button className="flex-1 px-4 py-2 text-sm font-medium text-foreground-700 border border-background-300 rounded-md hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                登录
              </button>
              <button className="flex-1 px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                注册
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}